export default  {
  bindings: {
      property: '<',
      formTab: '=',
      type: '@'
  },
  controller: 'propertyFinanceController',
  template: require('../views/property.finance.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/components/property.finance.form.component.js